import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable({ providedIn: 'root' })
export class FormValidationsService {

    getValidators(control: AbstractControl, pattern: string): ValidatorFn[] {
        const validators: ValidatorFn[] = [];

        if (pattern === 'email') {
            validators.push(this.emailValidator(control));
        } else if (pattern === 'password') {
            validators.push(this.passwordValidator(control));
        } else if (pattern === 'creditCard') {
            validators.push(this.creditCardValidator(control));
        } else if (pattern === 'phone') {
            validators.push(this.phoneValidator(control));
        } else if (pattern === 'url') {
            validators.push(this.urlValidator(control));
        } else if (pattern === 'slug') {
            validators.push(this.slugValidator(control));
        } else {
            validators.push(this.customPattern(control, pattern));
        }

        return validators;
    }

    private creditCardValidator(control: AbstractControl): ValidatorFn {
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        return (): { [key: string]: any } | null => {
            const validCreditCard = control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/);
            return !validCreditCard ? { 'invalidCreditCard': { value: control.value } } : null;
        };
    }

    private emailValidator(control: AbstractControl): ValidatorFn {
        return (): { [key: string]: any } | null => {
            const validEmail = control.value.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/);
            return !validEmail ? { 'invalidEmailAddress': { value: control.value } } : null;
        };
    }

    private passwordValidator(control: AbstractControl) {
        // {6,100}           - Assert password is between 6 and 100 characters
        // (?=.*[0-9])       - Assert a string has at least one number
        return (): { [key: string]: any } | null => {
            const validPassword = control.value.match(/^(?=.*[0-9])[a-zA-Z0-9!@#$%^&*]{6,100}$/);
            return !validPassword ? { 'invalidPassword': { value: control.value } } : null;
        };
    }

    private slugValidator(control: AbstractControl): ValidatorFn {
        return (): { [key: string]: any } | null => {
            const validSlug = control.value.match(/^[a-z0-9]+(\-[a-z0-9]+)*$/);
            return !validSlug ? { 'invalidSlug': { value: control.value } } : null;
        };
    }

    private urlValidator(control: AbstractControl): ValidatorFn {
        return (): { [key: string]: any } | null => {
            const validUrl = control.value.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:\/?#%[\]@!\$&'\(\)\*\+,;=.]+$/);
            return !validUrl ? { 'invalidUrl': { value: control.value } } : null;
        };
    }

    private phoneValidator(control: AbstractControl): ValidatorFn {
        return (): { [key: string]: any } | null => {
            const validPhone = control.value.match(/^\(*\+*[1-9]{0,3}\)*-*[1-9]{0,3}[-. /]*\(*[2-9]\d{2}\)*[-. /]*\d{3}[-. /]*\d{4} *e*x*t*\.* *\d{0,4}$/);
            return !validPhone ? { 'invalidPhone': { value: control.value } } : null;
        };
    }

    //custom validation
    private customPattern(control: AbstractControl, patterReg: string) {
      return (): { [key: string]: any } | null => {
        if (control.value) {
          const validPassword = control.value.match(patterReg);
          return !validPassword ? { 'customPattern': { value: control.value } } : null;
        } else {
          return null;
        }
      };
    }

}
